/* unplugin-vue-components disabled */import script from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=342abf44&lang=scss"

const __exports__ = script;

export default __exports__